export enum EnThemeMode {
  Default = 'dark-mode',
  White = 'white-mode',
  DarkHeader = 'dark-header',
}
